module.exports = __webpack_public_path__ + "img/QuoteBG.0ff3040d.jpeg";